import {ThunkActionCreator} from "../interfaces/thunk";
import {Dispatch} from "../interfaces/dispatch";
import Config from "../config";
import {getHeaders} from "../helpers/headers";
import {allCharts, ResetRecap, ResetRecapCharts} from "../interfaces/resetRecap";
import {AnyAction} from "../interfaces/action";
import {handleActions} from "redux-actions";
import axios from "axios";

export const FETCH_CHARTS_INFO_REQUEST = "FETCH_CHARTS_INFO_REQUEST"
export const FETCH_CHARTS_INFO = "FETCH_CHARTS_INFO"
export const FETCH_CHARTS_INFO_FAILED = "FETCH_CHARTS_INFO_FAILED"
export const FETCH_GAINING_BRANDS_REQUEST = "FETCH_GAINING_BRANDS_REQUEST";
export const FETCH_GAINING_BRANDS = "FETCH_GAINING_BRANDS";
export const FETCH_GAINING_BRANDS_FAILED = "FETCH_GAINING_BRANDS_FAILED";

export const FETCH_RESET_RECAP_COMPARISON_REQUEST = "FETCH_RESET_RECAP_COMPARISON_REQUEST";
export const FETCH_RESET_RECAP_COMPARISON = "FETCH_RESET_RECAP_COMPARISON";
export const FETCH_RESET_RECAP_COMPARISON_FAILED = "FETCH_RESET_RECAP_COMPARISON_FAILED";


let currentController: AbortController | null = null;

export function getCancelableAxios() {
  // Cancel the previous request if still pending
  if (currentController) {
    currentController.abort();
  }

  // Create a new controller for the latest request
  currentController = new AbortController();

  return { signal: currentController.signal };
}


const fetchGainingBrands: ThunkActionCreator<Promise<void>> = (id: number) => async (dispatch: Dispatch) => {
  dispatch({ type: FETCH_GAINING_BRANDS_REQUEST });

  try {
    const { signal } = getCancelableAxios(); // cancel previous request
    const response = await axios.get(
      `${Config.API_SERVICE_URL}/api/reports/gain-brands/${id}`,
      { ...getHeaders(), signal }
    );

    dispatch({ type: FETCH_GAINING_BRANDS, payload: response.data });
  } catch (err: any) {
    if (err.name === "CanceledError") {
      console.log("Previous request cancelled");
    } else {
      dispatch({ type: FETCH_GAINING_BRANDS_FAILED });
    }
  }
};

const fetchGraphInfo: ThunkActionCreator<Promise<void>> = (reqBody: any) => async (dispatch: Dispatch) => {
  const { signal } = getCancelableAxios();

  dispatch({ type: FETCH_CHARTS_INFO_REQUEST });

  try {
    const response = await axios.post(
      `${Config.API_SERVICE_URL}/api/reports/resetRecap`,
      reqBody,
      { ...getHeaders(), signal }
    );

    dispatch({ type: FETCH_CHARTS_INFO, payload: response.data });
  } catch (err: any) {
    if (err.name === "CanceledError") {
      console.log("Previous resetRecap request cancelled");
    } else {
      dispatch({ type: FETCH_CHARTS_INFO_FAILED });
    }
  }
};


const fetchResetRecapComparison: ThunkActionCreator<Promise<void>> =
  (baseProjectId: number, comparisonProjectId: number, storeIds: number[] = []) => async (dispatch: Dispatch) => {
    const { signal } = getCancelableAxios();

    dispatch({ type: FETCH_RESET_RECAP_COMPARISON_REQUEST });

    const body = {
      projectId: baseProjectId,
      comparisonId: comparisonProjectId,
      stores: storeIds
    };

    try {
      const response = await axios.post(
        `${Config.API_SERVICE_URL}/api/reports/resetRecapComparison`,
        body,
        { ...getHeaders(), signal }
      );

      dispatch({
        type: FETCH_RESET_RECAP_COMPARISON,
        payload: response.data
      });
    } catch (err: any) {
      if (err.name === "CanceledError") {
        // ✅ Do not dispatch FAILED here
        console.log("Previous resetRecapComparison request cancelled");
      } else {
        console.log("Comparison API error", err);
        dispatch({ type: FETCH_RESET_RECAP_COMPARISON_FAILED });
      }
    }
  };


const actions = {
  [FETCH_GAINING_BRANDS_REQUEST]: (state: ResetRecapState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_GAINING_BRANDS]: (state: ResetRecapState, action: AnyAction): ResetRecapState => ({
    ...state,
    loading: false,
    content: { ...action.payload },
  }),
  [FETCH_GAINING_BRANDS_FAILED]: (state: ResetRecapState) => ({
    ...state,
    loading: false,
    error: true,
    content: [],
  }),
  [FETCH_CHARTS_INFO_REQUEST]: (state: ResetRecapState) => ({
    ...state,
    loading: true,
    hasFetched: false,
  }),
  [FETCH_CHARTS_INFO]: (state: ResetRecapState, action: AnyAction): ResetRecapState => ({
    ...state,
    loading: false,
    chartsInfo: { allChartsInfo:{...action.payload} },
    hasFetched: true,
  }),
  [FETCH_CHARTS_INFO_FAILED]: (state: ResetRecapState) => ({
    ...state,
    loading: false,
    error: true,
    chartsInfo: {},
    hasFetched: true,
  }),

  [FETCH_RESET_RECAP_COMPARISON_REQUEST]: (state: ResetRecapState) => ({
    ...state,
    loading: true,
    hasFetched: false,
  }),

  [FETCH_RESET_RECAP_COMPARISON]: (state: ResetRecapState, action: AnyAction): ResetRecapState => ({
    ...state,
    loading: false,
    chartsInfo: { allChartsInfo: { ...action.payload } },
    hasFetched: true,
  }),

  [FETCH_RESET_RECAP_COMPARISON_FAILED]: (state: ResetRecapState) => ({
    ...state,
    loading: false,
    error: true,
    hasFetched: true,
  }),

}



export interface ResetRecapState {
  content: ResetRecap[];
  error: boolean;
  loading: boolean;
  chartsInfo:ResetRecapCharts;
  hasFetched: boolean;
}

const initialState: ResetRecapState = {
  loading: true,
  error: false,
  content: [],
  chartsInfo:{},
  hasFetched: false,
};




export {fetchGainingBrands,fetchGraphInfo, fetchResetRecapComparison}

export default handleActions<ResetRecapState, AnyAction>(actions, initialState);
